exports = module.exports = require("../../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui-label-online-status{display:-webkit-inline-box;display:-webkit-inline-flex;display:inline-flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row;-webkit-box-align:center;-webkit-align-items:center;align-items:center}.ui-label-online-status__icon{width:13px;height:13px;margin-right:3px;overflow:hidden}.ui-label-online-status__icon.icon-type-game{border-radius:4px}.ui-label-online-status__icon img{display:block;width:100%;height:100%;object-fit:cover}.ui-label-online-status__text{font-size:12px;font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!../src/ui/label/scss/online-status.scss
// module id = 554
// module chunks = 0 1 2 3